const reviews = [
  {
    image: require('../assets/electricalBg.jpg'),
    text: 'Impressed with the quality of OEM parts and expert service. My vehicle runs smoother than ever. Trustworthy and efficient - highly recommend AutoChef for all car needs!',
    name: 'Jonathan Taylor',
    position: 'CEO at Creativex',
  },
  {
    image: require('../assets/DetailingBg.jpg'),
    text: 'AutoChef provided excellent service, and my car has never been in better condition!',
    name: 'Emily Johnson',
    position: 'Marketing Director at TechCorp',
  },
  {
    image: require('../assets/DetailingBg.jpg'),
    text: 'Highly professional and reliable. The best auto service I have experienced.',
    name: 'Michael Brown',
    position: 'Engineer at BuildIt',
  },
  {
    image: require('../assets/electricalBg.jpg'),
    text: 'Impressed with the quality of OEM parts and expert service. My vehicle runs smoother than ever. Trustworthy and efficient - highly recommend AutoChef for all car needs!',
    name: 'Jonathan Taylor',
    position: 'CEO at Creativex',
  },
  {
    image: require('../assets/DetailingBg.jpg'),
    text: 'AutoChef provided excellent service, and my car has never been in better condition!',
    name: 'Emily Johnson',
    position: 'Marketing Director at TechCorp',
  },
  {
    image: require('../assets/DetailingBg.jpg'),
    text: 'Highly professional and reliable. The best auto service I have experienced.',
    name: 'Michael Brown',
    position: 'Engineer at BuildIt',
  },
];

export default reviews;